import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/lazy';
import { AuthService } from 'src/app/services/auth.service';
import { APIService } from 'src/app/services/api.service';
import { Router } from '@angular/router';

@Injectable()
export class GiftVoucherService {

    constructor(
        public alertController: AlertController,
        private authService: AuthService,
        private router: Router,
        private apiService: APIService
    ) { }

    getGiftVoucherByCode(gift_voucher_code, params) {
        return new Promise((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getGiftVoucherByCode(gift_voucher_code, params).then((gift_voucher: any) => {
                    resolve(gift_voucher);
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to get the gift voucher.");
                    } 
                    else if(error.status === 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view a gift voucher.");
                    } 
                    else if(error.status === 0) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve the gift voucher at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    getGiftVouchers(params) {
        return new Promise((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getGiftVouchers(params).then((gift_vouchers: any) => {
                    resolve(gift_vouchers);
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to get the gift vouchers.");
                    } 
                    else if(error.status === 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view gift vouchers.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve gift vouchers at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK'],
        });
        await alert.present();
    }

}
